import store from '@/store';
import router, { resetRouter } from '@/router/index';
import axios from 'axios';
import { Message, MessageBox } from 'element-ui';
import { Session } from '@/utils/storage';

// 创建 axios 实例
const service = axios.create({
	baseURL: process.env.VUE_APP_BASE_API,
	timeout: 50000,
	headers: { 'Content-Type': 'application/json' },
});

// 添加请求拦截器
service.interceptors.request.use(
	(config) => {
		let url = new URL(window.location.href);
		let token = url.searchParams.get('token');
		if(token!==null){
			config.headers.common['Authorization'] = `${'Bearer '+token}`;
		} else
		if (Session.get('token')) {
			config.headers.common['Authorization'] = `${'Bearer '+Session.get('token')}`;
		}
		if(config.isBolb){
			config.responseType='blob'
		}
		return config;
	},
	(error) => {
		// 对请求错误做些什么
		return Promise.reject(error);
	}
);

let isHandling401 = false; // 标记变量

// 添加响应拦截器
service.interceptors.response.use(
	(response) => {
		const {data,status} = response
		if(response.data.code == 401 || response.data.code == 4001){
			if (!isHandling401) {
				isHandling401 = true;
				//响应的状态码为401 或者 4001 token失效了 或者过期了 那就去登录
				// 清除浏览器全部临时缓存
				Session.clear();
				// router.push('/login');//此种方式跳转,如果接口返回401,重新登录后导致白屏
				store.commit('setMenuData', {});
				resetRouter(); // 重置路由
				MessageBox.alert('登录失效，请重新登录', '提示', {})
					.then(() => {
						router.push('/login?offline=1')
						isHandling401 = false;
					})
					.catch(() => {
						router.push('/login?offline=1')
						isHandling401 = false;
					});
				return Promise.reject(response.data)
			}
		}
		if(status>=200 && status<300){
			return Promise.resolve(data)
		}
		// const res = response.data;
		// if (res.code && res.code !== 0) {
		// 	// `token` 过期或者账号已在别处登录
		// 	if (res.code === 401 || res.code === 4001) {
		// 		// 清除浏览器全部临时缓存
		// 		Session.clear();
		// 		router.push('/login');
		// 		store.commit('setMenuData', {});
		// 		resetRouter(); // 重置路由
		// 		MessageBox.alert('你已被登出，请重新登录', '提示', {})
		// 			.then(() => {})
		// 			.catch(() => {});
		// 			return
		// 	}
		// 	return Promise.resolve(response.data);
		// } 
		// return response.data;
	},
	(error) => {
		if (error.code === 'ECONNABORTED' || error.message?.includes('timeout')) {
			// axios 官方超时错误码
			Message.error('网络超时');
		  } else if (error.message === 'Network Error') {
			// 网络错误
			Message.error('网络连接错误');
		  } else {
			// 其他错误（优先显示服务器返回的错误信息）
			const serverMsg = error.response?.data?.msg;
			Message.error(serverMsg || error.message || '未知错误');
		  }

		return Promise.reject(error);
	}
);

// 导出 axios 实例
export default service;
